import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { NAV, COMPANY } from "../mock";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-blue-50 shadow-[0_2px_10px_-6px_rgba(10,37,64,0.18)]">
      <div className="container-x flex items-center justify-between py-3">
        <Link to="/" className="flex items-center gap-3 group" aria-label="Fortunexis Finance">
          <img
            src="/brand/logo.png"
            alt="Fortunexis Finance"
            className="h-14 md:h-16 w-auto object-contain group-hover:scale-105 transition-transform"
          />
          <div className="hidden md:block leading-tight">
            <div className="text-[10px] uppercase tracking-[3px] text-[#d4a017] font-semibold">{COMPANY.tagline}</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((item) => (
            <div key={item.label} className={`has-dropdown relative`}>
              <Link to={item.href} className={`nav-link flex items-center gap-1 ${pathname === item.href ? "text-[#1e40af]" : ""}`}>
                {item.label}
                {item.children && <ChevronDown size={14} />}
              </Link>
              {item.children && (
                <div className="dropdown-menu">
                  {item.children.map((c) => (
                    <Link key={c.label} to={c.href}>{c.label}</Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <button onClick={() => setOpen(!open)} className="lg:hidden text-[#0a2540]" aria-label="toggle menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100">
          <div className="container-x py-4 flex flex-col">
            {NAV.map((item) => (
              <Link key={item.label} to={item.href} className="py-2 border-b border-slate-100 text-[#0a2540] font-medium" onClick={() => setOpen(false)}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
